import { FC } from 'react';
import { translate } from '../../i18n';
import { InstallmentOption } from '../InstallmentOption';
import { installmentSelectorStyles } from './styles';

export interface InstallmentPlanRates {
  cft: number;
  tea: number;
  tna: number;
}

export interface InstallmentPlan {
  id: string;
  months: number;
  monthlyAmount: number;
  totalAmount: number;
  interestRate?: string;
  /** CFT, TEA y TNA del plan (solo planes con interés). */
  rates?: InstallmentPlanRates;
  badge?: { text: string; variant: 'success' | 'warning' };
}

export interface InstallmentSelectorProps {
  plans?: InstallmentPlan[];
  selectedId?: string;
  onSelect?: (planId: string) => void;
  testID?: string;
  title?: string;
  /** Mientras corre `pre-initiate` para esta tarjeta. */
  loading?: boolean;
  /** Mensaje cuando falló la consulta de cuotas (si no se pasa, usa el texto por defecto). */
  errorMessage?: string;
}

/**
 * InstallmentSelector — Selector de opciones de pago en cuotas
 */
export const InstallmentSelector: FC<InstallmentSelectorProps> = ({
  plans = [],
  selectedId,
  onSelect,
  testID = 'installment-selector',
  title = translate('paymentsUI.installment.title'),
  loading = false,
  errorMessage,
}) => {
  const statusMessage = errorMessage ?? translate('paymentsUI.installment.unavailable');

  return (
    <fieldset style={installmentSelectorStyles.fieldset} data-testid={testID}>
      <legend style={installmentSelectorStyles.legend}>{title}</legend>

      {loading && (
        <p style={installmentSelectorStyles.statusText}>
          {translate('paymentsUI.installment.loading')}
        </p>
      )}

      {!loading && plans.length === 0 && (
        <p style={installmentSelectorStyles.errorText} role="alert">
          {statusMessage}
        </p>
      )}

      {!loading &&
        plans.length > 0 &&
        plans.map((plan) => (
          <InstallmentOption
            key={plan.id}
            months={plan.months}
            monthlyAmount={plan.monthlyAmount}
            totalAmount={plan.totalAmount}
            badge={plan.badge}
            interestRate={plan.interestRate}
            isSelected={plan.id === selectedId}
            onPress={() => onSelect?.(plan.id)}
          />
        ))}
    </fieldset>
  );
};
